import type { BaseTranslation } from '../i18n-types';

export const bannedUser = {
    explanation: {
        youBanned: 'Messaging Disabled: Account Blocked',
    },
} satisfies BaseTranslation;
